import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'
import merge from 'deepmerge'
import {
  mergeIds,
  compressAndFilter,
} from '@/utils'

const module = 'faceslist'
let doc = {
  list: {
    name: 'Dashboard',
    hasMap: true,
    headers: [
      { label: 'Code', value: 'code' },
      { label: 'Coté', value: 'board_side' },
      { label: 'Type', value: 'board_type' },
      { label: 'Adresse', value: 'adress' },
      { label: 'District', value: 'district' },
      { label: 'Ville', value: 'city' },
      { label: 'Region', value: 'region' },
    ],
    actions: [
      { icon: 'search', isFlat: true, dispatch: `${module}/openSearch` },
    ],
    dataActions: [
      { icon: 'visibility', isFlat: false, dispatch: `faces/goTo` },
      { icon: 'pie_chart', context: {field: 'id'}, dispatch: `tenancy/getTenancy` },
    ],
    search: [
      { label: 'Région', type: 'multilist', name: 'region_id', from: 'name', source: 'regions', classes: 'md6' },
      { label: 'Ville', type: 'multilist', name: 'city_id', from: 'name', source: 'cities', classes: 'md6' },
      { label: 'District', type: 'multilist', name: 'district_id', from: 'name', source: 'districts', classes: 'md6' },
      { label: 'Type', type: 'multilist', name: 'type_id', from: 'name', source: 'boardtypes', classes: 'md6' },
    ],
    selectActions: [
      {
        label: 'Rapport',
        icon: 'assignment',
        dispatch: `${module}/report`,
      },
      {
        label: 'Occupation',
        icon: 'pie_chart',
        dispatch: `tenancy/getMultiTenancy`,
        context: {field: 'id'},
      },
    ],
  },
  params: {
    fetchAll: {},
    fetchOne: {},
  },
}

const base = crudmaker(module, apiClient, doc)

const custom = {
  actions: {
    report: ({ commit }, payload) => {
      commit('SET_LOADING', true)
      const { data, context } = payload
      commit('EXPORT_REQUEST', payload)
      const contextParams = context.params ? context.params : {}
      const params = {id: mergeIds(data), ...contextParams}
      let cleaned = compressAndFilter(params)
      const callBack = event => { commit('EXPORT_PROGRESS', event) }
      apiClient._download('faces', `reports/faces`, {}, cleaned, callBack)
        .then(response => {
          commit('EXPORT_SUCCESS', response)
          commit('SET_LOADING', false)
        })
        .catch(error => {
          commit('EXPORT_ERROR', error)
          commit('SET_LOADING', false)
        })
    },

  },
}
export default merge(base, custom)
